"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Android_1 = __importDefault(require("../Icons/Android"));
var Apple_1 = __importDefault(require("../Icons/Apple"));
var Facebook_1 = __importDefault(require("../Icons/Facebook"));
var Fevad_1 = __importDefault(require("../Icons/Fevad"));
var Huawei_1 = __importDefault(require("../Icons/Huawei"));
var Instagram_1 = __importDefault(require("../Icons/Instagram"));
var ServiceClient_1 = __importDefault(require("../Icons/ServiceClient"));
var config = {
    awards: [{
            icon: Fevad_1.default,
            tooltip: {
                text: 'Adhérent à la FEVAD'
            }
        },
        {
            icon: ServiceClient_1.default,
            tooltip: {
                subText: 'Catégorie Vente à distance généraliste - Étude BVA Group - Viséo CI - mai à juillet 2019 - Plus d\'infos sur escda.fr',
                text: 'Service Client de l\'Année 2019'
            }
        }],
    columns: [
        {
            items: [
                {
                    linkProps: {
                        href: '//www.veepee.fr/gr/aboutus'
                    },
                    text: 'Qui sommes-nous ?'
                },
                {
                    linkProps: {
                        href: '//www.veepee.fr/postsales/contactselector'
                    },
                    text: 'Contactez-nous'
                },
                {
                    linkProps: {
                        href: '//aide.veepee.fr/article/984-securite-et-paiement'
                    },
                    text: 'Sécurité'
                },
                {
                    linkProps: {
                        href: '//aide.veepee.fr/article/389-mentions-legales'
                    },
                    text: 'Mentions légales'
                }
            ],
            title: 'Aide & Contact'
        },
        {
            items: [
                {
                    linkProps: {
                        href: '//www.veepee.fr/cguvoyage/fr-fr/static/index.html',
                        target: '_blank'
                    },
                    text: 'CGU Voyage'
                },
                {
                    linkProps: {
                        href: '//www.veepee.fr/ns/fr-fr/legal/privacy'
                    },
                    text: 'Politique de Confidentialité et Protection de la Vie Privée'
                },
                {
                    linkProps: {
                        href: '//www.veepee.fr/cguvoyage/fr-fr/classement_referencement_marketplace.pdf',
                        target: '_blank'
                    },
                    text: 'Classement/Référencement'
                }
            ],
            title: 'Conditions générales'
        },
        {
            items: [
                {
                    linkProps: {
                        href: '//careers.veepee.com/vptech-2/',
                        target: '_blank'
                    },
                    text: 'vpTech'
                },
                {
                    linkProps: {
                        href: '//careers.veepee.com/en/home-page-en',
                        target: '_blank'
                    },
                    text: 'Veepee'
                }
            ],
            title: 'Rejoignez-nous'
        },
        {
            items: [],
            title: ''
        }
    ],
    country: 'FR',
    flag: 'FR',
    header: {
        apps: {
            items: [
                {
                    icon: Apple_1.default,
                    label: 'iOS',
                    linkProps: {
                        href: '//apps.apple.com/fr/app/veepee-by-vente-privee/id906681058',
                        target: '_blank'
                    }
                },
                {
                    icon: Android_1.default,
                    label: 'Android',
                    linkProps: {
                        href: '//play.google.com/store/apps/details?id=com.venteprivee',
                        target: '_blank'
                    }
                },
                {
                    icon: Huawei_1.default,
                    label: 'Huawei',
                    linkProps: {
                        href: '//appstore.huawei.com/app/C101889749',
                        target: '_blank'
                    }
                }
            ],
            title: 'Nos applications'
        },
        social: [
            {
                icon: Instagram_1.default,
                label: 'Instagram',
                linkProps: {
                    href: '//www.instagram.com/veepeevoyage/',
                    target: '_blank'
                }
            },
            {
                icon: Facebook_1.default,
                label: 'Facebook',
                linkProps: {
                    href: '//www.facebook.com/veepeevoyage/',
                    target: '_blank'
                }
            }
        ]
    },
    lang: 'fr',
    logoSubtitle: 'VP, grandes marques à prix discount',
    mobile: {
        items: [
            {
                icon: Facebook_1.default,
                label: 'Facebook',
                linkProps: {
                    href: '//www.facebook.com/veepeevoyage/',
                    target: '_blank'
                }
            },
            {
                icon: Instagram_1.default,
                label: 'Instagram',
                linkProps: {
                    href: '//www.instagram.com/veepeevoyage/',
                    target: '_blank'
                }
            }
        ],
        title: 'Suivez-nous'
    }
};
exports.default = config;
